<template>
  <div>
    <span class="title">{{ title }}</span>
    <div class="options">
      <b-form-group>
        <b-form-radio-group v-model="selected" :options="options" :disabled="disabled"
          :stacked="stacked"></b-form-radio-group>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import Tip from "../shared/Tip.vue";

import { mapMutations, mapGetters } from "vuex";

export default {
  components: { Tip },
  name: "options",
  props: {
    title: String,
    options: Array,
    initialFieldTarget: String,
    fieldTarget: String,
    disabled: Boolean,
    stacked: Boolean,
    markFormDirty: {
      type: Boolean,
      default: true,
    },
    changed: Function,
    value: Number,
  },
  data() {
    return {
      selected: this.value,
    };
  },
  mounted() {
    if (this.initialFieldTarget) {
      let value = this.initialFieldTarget.value;
      let obj = { tag: `${this.title}: ${value}`, fieldTarget: this.fieldTarget, value: value };
      this.addFilter(obj);
    }
  },
  computed: {
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("validation", ["updateFormDirty"]),
    ...mapMutations("generic", ["addFilter"]),
  },
  watch: {
    value() {
      this.selected = this.value;
    },
    selected() {
      this.$emit("input", this.selected);

      if (this.markFormDirty) this.updateFormDirty(true);
      if (this.changed) this.changed();
      if (this.fieldTarget) {
        let obj = { tag: `${this.title}: ${this.selected}`, fieldTarget: this.fieldTarget, value: this.selected };
        this.addFilter(obj);
      }
    },
    event: {
      handler(event) {
        if (event.name == "tagRemoved") {
          if (this.fieldTarget == event.data)
            this.$emit("input", "");
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.options {
  margin-top: 5px;
}
</style>
